import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=87432bea&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=ts"
export * from "./Fields.vue?vue&type=script&lang=ts"
import style0 from "./Fields.vue?vue&type=style&index=0&id=87432bea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87432bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
